/* eslint-disable max-len */
import { useMutation } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const postUserDeliveryAddress = async (deliveryaddressid, supplieruserid) => {
  const token = localStorage.getItem('token');
  return customAxios({
    method: 'post',
    data: { deliveryaddressid, supplieruserid },
    url: '/supplier/user/delivery/address/',
    headers: { Authorization: `Bearer ${token}` },
  });
};

const usePostUserDeliveryAddress = () => useMutation(({ deliveryaddressid, supplieruserid }) => postUserDeliveryAddress(deliveryaddressid, supplieruserid));

export default usePostUserDeliveryAddress;
